import { COUNCIL } from "@/lib/council";
import type { VerdictDissidence } from "@/hooks/use-verdict";

function sanitize(html: string): string {
  const escaped = html
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
  return escaped
    .replace(/&lt;strong&gt;/g, '<strong class="diss-strong">')
    .replace(/&lt;\/strong&gt;/g, "</strong>")
    .replace(/&lt;em&gt;/g, '<em class="diss-em">')
    .replace(/&lt;\/em&gt;/g, "</em>");
}

type Props = { dissidence: VerdictDissidence };

export function DissidenceCard({ dissidence }: Props) {
  const c = dissidence.persona
    ? COUNCIL.find((x) => x.id === dissidence.persona)
    : undefined;
  const displayName = c?.name ?? dissidence.name ?? "Conseil";

  return (
    <div
      data-testid="dissidence-card"
      data-rp="dissidence-card"
      style={{
        border: "0.5px solid var(--qv3-grey-100)",
        borderLeft: "2px solid var(--qv3-gold)",
        padding: "24px 28px",
        background: "transparent",
        marginBottom: 56,
      }}
    >
      <div
        style={{
          fontFamily: "var(--qv3-font-mono)",
          fontSize: 10,
          color: "var(--qv3-gold)",
          letterSpacing: 3,
          textTransform: "uppercase",
          marginBottom: 14,
        }}
      >
        Note de dissidence
      </div>
      <div
        style={{
          fontFamily: "var(--qv3-font-serif)",
          fontStyle: "italic",
          fontWeight: 300,
          fontSize: 18,
          color: "var(--qv3-ink)",
          lineHeight: 1.55,
          letterSpacing: "-0.01em",
        }}
        dangerouslySetInnerHTML={{ __html: sanitize(dissidence.text) }}
      />
      <div
        style={{
          marginTop: 14,
          fontFamily: "var(--qv3-font-mono)",
          fontSize: 10,
          color: "var(--qv3-grey-500)",
          letterSpacing: 2,
          textTransform: "uppercase",
        }}
      >
        — {displayName} · {dissidence.role}
      </div>
      <style>{`
        .diss-strong{font-style:normal;font-weight:500;color:var(--qv3-gold);}
        .diss-em{font-style:italic;}
      `}</style>
    </div>
  );
}

export default DissidenceCard;
